import script from "./renameGroupDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./renameGroupDialog.vue?vue&type=script&lang=ts&setup=true"

import "./renameGroupDialog.vue?vue&type=style&index=0&id=4dd9308c&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd9308c"]])

export default __exports__